module.exports = __webpack_public_path__ + "img/31.70ce3bc1.png";